import { HandlingUnitType } from "@freightsimple/generated-dashboard-openapi-client/models/HandlingUnitType";

export interface HandlingUnitTypeInfo {
  singular: string;
  plural: string;
  type: HandlingUnitType;
  preposition: string;
  alternateMenuName?: string | undefined;
}

export const handlingUnitTypes: HandlingUnitTypeInfo[] = [
  {
    singular: "Bin",
    plural: "Bins",
    type: HandlingUnitType.Bin,
    preposition: "in",
  },
  {
    singular: "Box",
    plural: "Boxes",
    type: HandlingUnitType.Box,
    preposition: "in",
  },
  {
    singular: "Bundle",
    plural: "Bundles",
    type: HandlingUnitType.Bundle,
    preposition: "in",
  },
  {
    singular: "Cage",
    plural: "Cages",
    type: HandlingUnitType.Cage,
    preposition: "in",
  },
  {
    singular: "Crate",
    plural: "Crates",
    type: HandlingUnitType.Crate,
    preposition: "in",
  },
  {
    singular: "Drum",
    plural: "Drums",
    type: HandlingUnitType.Drum,
    preposition: "in",
  },
  {
    singular: "Pallet",
    plural: "Pallets",
    type: HandlingUnitType.Pallet,
    preposition: "on",
  },
  {
    singular: "Reel",
    plural: "Reels",
    type: HandlingUnitType.Reel,
    preposition: "in",
  },
  {
    singular: "Roll",
    plural: "Rolls",
    type: HandlingUnitType.Roll,
    preposition: "in",
  },
  {
    singular: "Skid",
    plural: "Skids",
    type: HandlingUnitType.Skid,
    preposition: "on",
  },
  {
    singular: "Item",
    plural: "Items",
    type: HandlingUnitType.Loose,
    alternateMenuName: "Loose Item",
    preposition: "",
  },
  {
    singular: "Unit",
    plural: "Units",
    type: HandlingUnitType.Other,
    alternateMenuName: "Other",
    preposition: "in",
  },
];
